module.exports = __webpack_public_path__ + "themes/mf/img/prize-6.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-6.png
// module id = 96
// module chunks = 3